class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show')?.classList.remove('show');
document.querySelector('.previewCart')?.classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show')?.classList.remove('show');
document.querySelector('.previewCart')?.classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
            Shopify.getCart((cart) => {window.sharedFunctions?.updateSidebarCart(cart)});
          });
      document.querySelector('.popup-toolDown.show')?.classList.remove('show');
document.querySelector('.previewCart')?.classList.remove('active-tool');
    })
  }
}

customElements.define('coupon-code', CouponCode);

// --- GIFT WITH PURCHASE NATIVE LOGIC ---
document.addEventListener('cart-update', function(e) {
    const cart = e.detail;
    
    // 1. Check if the feature is enabled and variables exist
    if (!window.gift_with_purchase || !window.gift_with_purchase.enabled || !window.gift_with_purchase.gift_variant_id) return;

    const qualifyingIds = window.gift_with_purchase.qualifying_ids;
    const giftVariantId = window.gift_with_purchase.gift_variant_id;

    // 2. Check for qualifying items (Shoes)
    const hasQualifyingItem = cart.items.some(item => qualifyingIds.includes(item.product_id));
    
    // 3. Find the FREE gift item
    const freeGiftItem = cart.items.find(item => 
        item.variant_id === giftVariantId && 
        item.properties !== null && 
        item.properties['_is_free_gift'] === 'true'
    );
    const hasFreeGift = !!freeGiftItem; 

    // 4. Find if they already have a PAID version of the socks in the cart
    const paidGiftItem = cart.items.find(item => 
        item.variant_id === giftVariantId && 
        (item.properties === null || item.properties['_is_free_gift'] !== 'true')
    );

    // 5. Logic: Add/Convert gift, or remove gift
    if (hasQualifyingItem && !hasFreeGift) {
        
        // Step A: Add the free gift
        let formData = {
            'items': [{
                'id': giftVariantId,
                'quantity': 1,
                'properties': {
                    '_is_free_gift': 'true' 
                }
            }]
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(() => {
            // Step B: If there was a paid pair, reduce its quantity by 1
            if (paidGiftItem) {
                return fetch(window.Shopify.routes.root + 'cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        'id': String(paidGiftItem.key),
                        'quantity': paidGiftItem.quantity - 1 // Subtracts 1 from the paid item
                    })
                }).then(res => res.json());
            }
        })
        .then(() => {
            // Step C: Finally, update the visual cart
            Shopify.getCart((updatedCart) => {
                window.sharedFunctions?.updateSidebarCart(updatedCart);
            });
        })
        .catch(error => console.error('Error adding free gift:', error));

    } else if (!hasQualifyingItem && hasFreeGift) {
        // Automatically remove ONLY the free gift using its unique key
        fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                'id': String(freeGiftItem.key), 
                'quantity': 0
            })
        })
        .then(response => response.json())
        .then(() => {
            Shopify.getCart((updatedCart) => {
                window.sharedFunctions?.updateSidebarCart(updatedCart);
            });
        })
        .catch(error => console.error('Error removing free gift:', error));
    }
});